// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search_8h5zU","input":"search_input_3xqt0"};